import { Component, Input, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalRef } from '@siemens/element-ng/modal';

@Component({
    selector: 'app-popup-error',
    templateUrl: './popup-error.component.html',
    styleUrls: ['./popup-error.component.scss'],
    imports: [TranslatePipe]
})
export class PopupErrorComponent {
    private readonly modalRef = inject<ModalRef<unknown, string>>(ModalRef);

    @Input() data: {
        id: string;
        title: string;
        body: string;
    } = {
        id: 'error',
        title: 'popup.error.title',
        body: 'popup.error.body'
    };

    closeDialog(): void {
        this.modalRef.hide('close');
    }
}
